export const getBannerTableColums = (params?: any) => {
  return [
    {
      id: "order",
      label: `Order`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "title",
      label: `Title`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "navigationPath",
      label: `Navigation Path`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "body",
      label: `Body`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "textColor",
      label: `Text Color`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "isActiveText",
      label: `Is Active`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    { id: "thumbnail", label: "Preview" },
    { id: "actions", label: "Actions" },
  ];
};
